import { useRef } from "react";
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import BannerQuick from "../common/quick/BannerQuick";
import FlowText from "./FlowText";
import ModalPop from "./ModalPop";
import useDeviceType from "../common/useDeviceType";

import "swiper/css/effect-fade";

const Banner = () => {
  const isMobile = useDeviceType();

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  const bannerList = [
    {
      id: 1,
      pc: "/images/bannerTxt1.png",
      icon: "/images/bannerIcon1.png",
      mo: "/images/bannerMoT1.png",
    },
    {
      id: 2,
      pc: "/images/bannerTxt2.png",
      icon: "/images/bannerIcon2.png",
      mo: "/images/bannerMoT2.png",
    },
    {
      id: 3,
      pc: "/images/bannerTxt1.png",
      icon: "/images/bannerIcon1.png",
      mo: "/images/bannerMoT1.png",
    },
    {
      id: 4,
      pc: "/images/bannerTxt2.png",
      icon: "/images/bannerIcon2.png",
      mo: "/images/bannerMoT2.png",
    },
    {
      id: 5,
      pc: "/images/bannerTxt1.png",
      icon: "/images/bannerIcon1.png",
      mo: "/images/bannerMoT1.png",
    },
    {
      id: 6,
      pc: "/images/bannerTxt2.png",
      icon: "/images/bannerIcon2.png",
      mo: "/images/bannerMoT2.png",
    },
  ];
  return (
    <div
      id="banner"
      className="relative w-full h-full mt-16 xl:mt-[126px] bg-primary"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="absolute left-0 top-0 w-full xl:w-1/2 h-full">
        <img
          src="/images/banner1.png"
          alt="누수공사"
          className="relative w-full h-full object-cover object-center"
        />
      </div>
      <Swiper
        slidesPerView={1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        }}
        fadeEffect={{
          crossFade: true,
        }}
        speed={600}
        effect={"fade"}
        loop={true}
        loopAdditionalSlides={2}
        modules={[Autoplay, EffectFade]}
        className="relative w-full h-full pt-10 lg:pt-16"
      >
        {bannerList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full xl:grid xl:grid-cols-2 px-2 xl:px-0"
          >
            <div className=" relative w-full h-full">
              {/* 고정 사람 */}
              <img
                src={v.icon}
                alt="누수 서비스 배경 아이콘"
                className="hidden xl:inline-block absolute bottom-0 -right-40 h-full object-contain pointer-events-none xl:scale-125"
              />
              <img
                src={isMobile ? v.mo : v.pc}
                alt="누수탐지"
                className="!relative w-auto h-full p-6 lg:p-0 object-contain max-h-80 lg:max-h-56 mx-auto lg:mr-52"
              />
              {/* 버튼 이미지 영역 */}
              <div className="relative w-fit h-fit ml-auto lg:mr-48 mt-6 xl:mt-12 px-4 lg:px-0 pb-5 lg:pb-12">
                <div className="relative w-full h-fit flex justify-end gap-2 lg:gap-5 max-w-[460px] ">
                  <button
                    type="button"
                    onClick={openfunc}
                    className="block w-full transition hover:scale-[1.02] active:scale-[0.98]"
                  >
                    <img
                      src={"/images/bannerBtn1.png"}
                      alt="긴급출동"
                      className="h-auto w-full object-contain"
                    />
                  </button>

                  <button
                    type="button"
                    onClick={() => (window.location.href = "tel:010-8912-1202")}
                    className="block w-full transition hover:scale-[1.02] active:scale-[0.98]"
                    aria-label="빠른 전화상담"
                  >
                    <img
                      src={"/images/bannerBtn2.png"}
                      alt="빠른 전화상담"
                      className="h-auto w-full object-contain"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="w-0 h-0"></div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="relative xl:absolute right-0 lg:top-6 xl:top-12 w-full xl:w-1/2 h-full">
        <div className=" relative w-fit h-fit mx-auto lg:ml-48">
          <BannerQuick />
        </div>
      </div>
      <div className="relative w-full h-full bg-secondary py-4 xl:pl-10">
        <FlowText />
      </div>
    </div>
  );
};

export default Banner;
